<div role="dialog" aria-labelledby="chatConfirmDialogTitle">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="chatConfirmDialogTitle">{{ 'chat.dialog.confirmTitle' | translate }}</h4>
      <button
        type="button"
        class="btn-close"
        (click)="cancel()"
        [attr.aria-label]="'chat.dialog.cancel' | translate"
      ></button>
    </div>
    <div class="modal-body">
      {{ message }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="cancel()">
        {{ 'chat.dialog.cancel' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="confirm()">
        {{ 'chat.dialog.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
